import type { NavItem } from '@/types';

export const navItems: NavItem[] = [
  { label: 'About', path: '/about' },
  { label: 'Services', path: '/services' },
  { label: 'Work', path: '/work' },
  { label: 'Process', path: '/process' },
  { label: 'Contact', path: '/contact' },
];
